import Vue from 'vue'
import CONFIG from './../../config.js'

let actions = {
  userDetails (context, params) {
    context.commit('addLog', { request: 'userDetails' })
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint('userDetails'), {
          params: params,
          withCredentials: true
        })
        .then(response => {
          context.commit('userDetails', response.data)
          if (response.data.dmi && response.data.dmi.leadId && !response.data.dmi.ekycCompleted) {
            context.dispatch('dmiVerify', response.data.dmi.leadId)
          }
          setTimeout(function () {
            context.commit('removeLog', { request: 'userDetails' })
          }, 1000)
          resolve(response.data)
        })
        .catch((err) => {
          setTimeout(function () {
            context.commit('removeLog', { request: 'userDetails' })
          }, 1000)
          reject(err)
        })
    });
  },
  pinCode (context, params) {
    context.commit('addLog', { request: 'pinCode' })
    Vue.axios
      .get(
        `https://verify.epaylater.in/credit-application/${
        params.pincode
        }/pincode`,
        {
          withCredentials: true
        }
      )
      .then(response => {
        context.commit('pinCode', {
          response: response.data,
          personal: params.personal
        })
        setTimeout(function () {
          context.commit('removeLog', { request: 'invalidPinCode' })
        }, 1000)
      })
      .catch(() => {
        context.commit('invalidPinCode', {
          status: true,
          personal: params.personal
        })
        setTimeout(function () {
          context.commit('removeLog', { request: 'pinCode' })
          context.commit('removeLog', { request: 'invalidPinCode' })
        }, 1000)
      })
  },
  dmiStart (context, params) {
    context.commit('addLog', { request: 'dmiStart' })
    // console.log(params)

    Vue.axios
      .post(CONFIG.getEndpoint('dmiStart'), params, {
        withCredentials: true,
        xsrfCookieName: 'SSO_TOKEN'
      })
      .then(response => {
        context.commit('removeLog', { request: 'dmiStart' })
        context.dispatch('dmiVerify', response.data.leadId)
      })
      .catch(() => {
        context.commit('removeLog', { request: 'dmiStart' })
      })
  },
  dmiVerify (context, leadId) {
    // console.log(leadId)

    const form = document.createElement('form')
    const element1 = document.createElement('input')
    const element2 = document.createElement('input')
    const element3 = document.createElement('input')
    form.method = 'POST'
    form.action = `${CONFIG.API_BASE_URI}/api/v1/dmi/okyc/verify`
    element1.value = 'AADHAAR_ZIP_INLINE'
    element1.name = 'oKycType'
    form.appendChild(element1)
    element2.value = 'OKYC_WAPP'
    element2.name = 'source'
    form.appendChild(element2)
    element3.value = leadId
    element3.name = 'leadId'
    form.appendChild(element3)
    document.body.appendChild(form)
    form.submit()
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/dmi/actions.js